import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { SectionLabel } from "@/components/shared";
import { WaiverForm } from "@/components/WaiverForm";

export default function Waiver() {
  const { regId } = useParams();
  const [reg, setReg] = useState(null);
  const [state, setState] = useState("loading"); // loading | ready | signed | notfound

  useEffect(() => {
    api
      .get(`/registrations/${regId}/public`)
      .then(({ data }) => {
        setReg(data);
        setState(data.waiver_signed ? "signed" : "ready");
      })
      .catch(() => setState("notfound"));
  }, [regId]);

  return (
    <div data-testid="waiver-page">
      <section className="relative overflow-hidden pb-10 pt-40 md:pt-48">
        <div className="mx-auto max-w-2xl px-5 md:px-10">
          <SectionLabel>Liability Waiver</SectionLabel>
          <h1 className="font-heading text-5xl uppercase leading-[0.85] tracking-tight text-white sm:text-7xl">
            Sign The <span className="text-neon-green">Waiver</span>
          </h1>
        </div>
      </section>

      <section className="relative z-10 bg-obsidian pb-28">
        <div className="mx-auto max-w-2xl px-5 md:px-10">
          <div className="border border-white/10 bg-surface p-6 sm:p-10">
            {state === "loading" && (
              <div className="flex items-center justify-center py-16 text-neon-green"><Loader2 className="animate-spin" size={28} /></div>
            )}
            {state === "notfound" && (
              <p data-testid="waiver-notfound" className="py-10 text-center font-body text-white/60">
                We couldn't find that registration. Please <Link to="/register" className="text-neon-green underline">sign up here</Link>.
              </p>
            )}
            {state === "signed" && (
              <div data-testid="waiver-already-signed" className="border border-neon-green/40 bg-zinc-900 p-10 text-center neon-glow">
                <CheckCircle2 size={48} strokeWidth={2.5} className="mx-auto text-neon-green" />
                <h3 className="mt-5 font-heading text-3xl uppercase text-white">Already Signed</h3>
                <p className="mt-3 font-body text-sm text-white/60">This player's waiver is already on file. You're all set!</p>
              </div>
            )}
            {state === "ready" && reg && (
              <>
                <div className="mb-6 border border-neon-green/40 bg-zinc-900 px-5 py-4">
                  <p className="font-body text-sm text-white/80">
                    Completing the waiver for <span className="text-neon-green">{reg.player_name}</span> ({reg.age_group} group).
                  </p>
                </div>
                <WaiverForm regId={regId} prefill={{ player_name: reg.player_name, guardian_name: reg.guardian_name, phone: reg.phone, age_group: reg.age_group }} />
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
